module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_hairmake-b231d17fa3280f63d9fce682287f9366.jpg";